/* vitae · Apolinář landing (sections/vitae-apolinar.liquid): the live "right now, by your bed" card
   and the copy-code button. Colours and the band itself come from the sky theme
   (assets/vitae-sky.js → window.vitaeSky + the "vitae:sky" event); the band buttons preview the page
   at that hour through vitaeSky.preview(). */
(function () {
  "use strict";
  var STOPS = [[0, "#8E2418"], [4, "#B8321B"], [5, "#D9531E"], [6, "#F0A03A"], [7, "#F5D26B"], [8, "#A9CDEB"], [9, "#6FB1E8"], [12, "#5AA7EA"], [15, "#6FB1E8"], [17, "#A9CDEB"], [18, "#F5C24A"], [19, "#F0862E"], [20, "#D9531E"], [21, "#B8321B"], [23, "#8E2418"]];
  function h2r(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
  function skyAt(h) {
    if (window.vitaeSky && window.vitaeSky.at) return window.vitaeSky.at(h);
    var a = STOPS[0], b = STOPS[STOPS.length - 1];
    for (var i = 0; i < STOPS.length - 1; i++) if (h >= STOPS[i][0] && h <= STOPS[i + 1][0]) { a = STOPS[i]; b = STOPS[i + 1]; break; }
    var u = a[0] === b[0] ? 0 : (h - a[0]) / (b[0] - a[0]), ca = h2r(a[1]), cb = h2r(b[1]);
    return "rgb(" + ca.map(function (v, j) { return Math.round(v + (cb[j] - v) * u); }).join(",") + ")";
  }
  function bandAt(h) { return h >= 21 || h < 6 ? "noc" : h >= 20 ? "pred" : h >= 18 ? "vecer" : "den"; }
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  function initNow(card) {
    if (card.dataset.ready) return; card.dataset.ready = "1";
    var S = {}; try { S = JSON.parse(card.querySelector("[data-ap-strings]").textContent); } catch (e) { S = { bands: {}, rec: {} }; }
    var clock = card.querySelector("[data-ap-clock]"), name = card.querySelector("[data-ap-band-name]"), rec = card.querySelector("[data-ap-rec]"), note = card.querySelector("[data-ap-note]"), back = card.querySelector("[data-ap-back]");
    var segs = card.querySelectorAll("[data-ap-bar] span"), btns = card.querySelectorAll(".ap-now-bands button");
    var sky = window.vitaeSky;
    if (!sky) card.classList.add("no-sky");
    segs.forEach(function (sp, i) { sp.style.setProperty("--seg", skyAt(i + 0.5)); });
    function render() {
      var now = new Date(), h = now.getHours(), cur = sky && sky.current ? sky.current() : { band: bandAt(h), preview: null };
      var b = cur.preview || cur.band || bandAt(h), preview = !!cur.preview;
      if (clock) clock.textContent = pad(h) + ":" + pad(now.getMinutes());
      if (name) name.textContent = S.bands[b] || b;
      if (rec) rec.innerHTML = S.rec[b] || "";
      if (note) note.textContent = preview ? S.notePreview : S.noteAuto;
      card.classList.toggle("preview", preview);
      btns.forEach(function (bt) { bt.classList.toggle("on", bt.dataset.band === b); bt.setAttribute("aria-pressed", bt.dataset.band === b ? "true" : "false"); });
      segs.forEach(function (sp, i) { sp.classList.toggle("cur", !preview && i === h); });
    }
    btns.forEach(function (bt) {
      bt.addEventListener("click", function () {
        if (!sky) return;
        var live = bandAt(new Date().getHours());
        sky.preview(bt.dataset.band === live ? null : bt.dataset.band, false);
        render();
      });
    });
    if (back) back.addEventListener("click", function () { if (sky) sky.preview(null, false); render(); });
    document.addEventListener("vitae:sky", render);
    render(); setInterval(render, 15000);
  }

  function initCopy(b) {
    if (b.dataset.ready) return; b.dataset.ready = "1";
    b.addEventListener("click", function () {
      var t = b.getAttribute("data-ap-copy"), orig = b.textContent;
      var done = function () { b.textContent = b.getAttribute("data-copied") || orig; setTimeout(function () { b.textContent = orig; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(done, done); else done();
    });
  }

  function boot() {
    document.querySelectorAll("[data-ap-now]").forEach(initNow);
    document.querySelectorAll("[data-ap-copy]").forEach(initCopy);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
